import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import type { Lookups } from '../types/models';

export const LOOKUPS_KEY = ['lookups'] as const;

/** Reference lists for dropdowns (cached; invalidated after master-data changes). */
export function useLookups() {
  return useQuery({
    queryKey: LOOKUPS_KEY,
    queryFn: () => api.get<Lookups>('/lookups'),
    staleTime: 5 * 60_000,
  });
}
